
import { Form, Button, ButtonGroup, Row, Col } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";


import { FiUpload } from 'react-icons/fi'
import { BsFileEarmarkRichtext } from "react-icons/bs"
import { GoTrash } from "react-icons/go"
import { IoPersonAddSharp } from "react-icons/io5";
import PartecipanteService from "../../services/PartecipanteService";

/**
 * Componente per il caricamento e l'elaborazione di un file CSV contenente partecipanti.
 * Permette di caricare un file CSV, visualizzare i dettagli del file e inviare il file al backend per l'importazione.
 *
 * @param {Number} props.comId - ID del comune di riferimento.
 * @param {Function} props.setTitoloToast - Funzione per impostare il titolo del toast.
 * @param {Function} props.setMessaggioToast - Funzione per impostare il messaggio del toast.
 * @param {Function} props.setShowToast - Funzione per mostrare il toast di notifica.
 * @param {Function} props.setRicaricaPartecipanti - Funzione per aggiornare la lista dei partecipanti.
 */
export default function BottoneFile(props) {

    //stato per i file caricati, metadata e arrayBuffer
    const [uploadedFilesMetadata, setUploadedFilesMetadata] = useState([])

    // Stato per la gestione degli errori durante l'importazione
    const [erroriImport, setErroriImport] = useState("")

    // Riferimento all'input file
    let inputFile = useRef(null)


    /**
     * Apre la finestra di selezione file quando si preme il pulsante "Carica".
     */
    const handleUpload = (event) => {
        event.preventDefault()
        inputFile?.click();
    };

    /**
     * Cancella il file selezionato, svuotando lo stato e il campo input.
     */
    const deleteFile = () => {
        setUploadedFilesMetadata([])
        inputFile.value=""
    }

    //FILE
    /**
     * Gestisce la selezione e la validazione del file caricato.
     * Controlla:
     * - Che la dimensione del file sia inferiore a 10MB.
     * - Che non ci sia già un file caricato.
     */
    const handleDisplayFileDetails = async () => {
        if (inputFile?.files && inputFile.files[0]
            && inputFile.files[0].size <= 10000 * 1024 //controlla grandezza file < 10000kB 
          /*  && acceptedExtensions.includes(inputFile.files[0].type) //controlla estensione */
            && uploadedFilesMetadata.length < 1  //controlla # allegati
        ) {
            setUploadedFilesMetadata(old => [...old, inputFile.files[0]])
            setErroriImport("")
        } else {
             // Gestione errori
            if (uploadedFilesMetadata.length >= 1) setErroriImport("Non puoi allegare più di un allegato.")
            else if (uploadedFilesMetadata.filter(file => file.name === inputFile.files[0].name).length > 1) setErroriImport("Non puoi caricare file con lo stesso nome.")
            //else if (!acceptedExtensions.includes(inputFile.files[0].type)) setErroriImport("Il formato del file scelto non è accettabile.")
            else if (!inputFile.files[0].size <= 102400) setErroriImport("Il file scelto è troppo grande. Riprova.")
        }

    }


    /**
     * Invia il file caricato al backend per l'elaborazione.
     */
    const handleSubmit = () => {
        var formData = new FormData()
        uploadedFilesMetadata.forEach(el => {
        formData.append("file", el)
    })

    // Effettua la chiamata al backend per importare il file
        PartecipanteService.importPartecipanti( props.comId, formData)
            .then(() => {
                props.setTitoloToast("Caricamento CSV partecipanti")
                props.setMessaggioToast("La registrazione dei nuovi partecipanti é stata eseguita con successo!")
                props.setShowToast(true)
                props.setRicaricaPartecipanti(true)
                //setMostraModaleOk(true)
           })
            .catch((err) => {
              setErroriImport(err.response.data)
            })
    }

    // Effetto per nascondere l'errore dopo 3 secondi
    useEffect(() => {
        if (erroriImport) {
            const timer = setTimeout(() => {
                setErroriImport("");
            }, 3000);

            return () => clearTimeout(timer); // Pulizia del timer quando l'errore cambia
        }
    }, [erroriImport]);

    return (
        <>
            <Row>
                <Col>
                {/* Input nascosto per il caricamento file */}
                    <input
                        className="d-none"
                        type="file"
                        accept=".csv"
                        ref={el => inputFile = el}
                        onInput={handleDisplayFileDetails} />
                        {/* Pulsante per caricare un file */}
                    <Button className="mb-3"
                        onClick={handleUpload} >
                        <FiUpload className="me-2" size="1em" /> Carica
                    </Button>
                </Col>
                {/* Mostra il nome del file caricato con possibilità di rimuoverlo */}
                <Col xs={8} className="text-center">
                    {uploadedFilesMetadata.length > 0 && uploadedFilesMetadata.map((el, i) => (
                        <ButtonGroup key={i} className="me-3 mb-3">
                            <Button variant="outline-primary" > <BsFileEarmarkRichtext size="1.5em" /> {el.name}</Button>
                            <Button variant="outline-danger" onClick={() => { deleteFile(el.name) }}> <GoTrash size="1.5em" /></Button>
                        </ButtonGroup>
                    ))}
                </Col>
                <Col className="text-center">
                {/* Mostra il pulsante di elaborazione solo se è stato caricato un file */}
                    {uploadedFilesMetadata.length > 0 &&
                        <Button className="mb-3"  onClick={handleSubmit}                       >
                            <IoPersonAddSharp className="me-2" size="1em" /> Elabora
                        </Button>
                    }
                </Col>
            </Row>
             {/* Mostra messaggi di errore in caso di problemi con l'upload */}
            {erroriImport &&
                <Form.Label className="mt-1 text-danger d-block"><strong>
                    {erroriImport}
                </strong>
                </Form.Label>}
        </>
    )
}